import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import keyFeaturesStyles from './keyFeaturesStyles';
import SpecificationDisclaimer from '../../../../../../gqlCommon/components/presentation/specificationDisclaimer/SpecificationDisclaimer';

interface IKeyFeature {
  shortname: string;
  disclaimer?: string;
}

export const KeyFeature: FunctionComponent<IKeyFeature> = ({ shortname, disclaimer }) => {
  const styles = keyFeaturesStyles();
  return (
    <Box className={styles.descriptionContainer} data-test="customise:featuresItemContainer">
      <Typography variant="caption" className={styles.description} data-test="customise:featuresItem">
        {shortname}
      </Typography>
      {disclaimer && <SpecificationDisclaimer disclaimer={disclaimer} />}
    </Box>
  );
};
